import {ReportModel} from "@fedeltapointofsale/data-client";
import {SalesByHalfHourReportData} from "./sales-by-half-hour-report.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class SalesByHalfHourReportModel extends ReportModel<SalesByHalfHourReportData> {
    constructor(injector: Injector) {
        super(injector, SalesByHalfHourReportData);
    }
}
